import humps from 'humps'
import * as widgetsServices from '_services/widgets'
import { defineAction } from '_utils/redux'
import { notEmptyPayload } from '_utils/helpers'

export const GET_SERVICE_ORDERS_COUNT_WIDGET = defineAction('GET_SERVICE_ORDERS_COUNT_WIDGET')
export const GET_WIDGETS_OPTIONS = defineAction('GET_WIDGETS_OPTIONS')
export const SET_WIDGETS_FILTER = defineAction('SET_WIDGETS_FILTER')
export const GET_WIDGET_RESULTS = defineAction('GET_WIDGET_RESULTS')
export const GET_WIDGETS_LIST = defineAction('GET_WIDGETS_LIST')
export const CREATE_WIDGET = defineAction('CREATE_WIDGET')
export const GET_WIDGET_DETAILS = defineAction('GET_WIDGET_DETAILS')
export const UPDATE_WIDGET = defineAction('UPDATE_WIDGET')
export const DELETE_WIDGET = defineAction('DELETE_WIDGET')

export const setWidgetsFilter = payload => dispatch =>
  dispatch({
    type: SET_WIDGETS_FILTER.ACTION,
    payload,
  })

export const getServiceOrdersCountWidgets = params => (dispatch, getState) => {
  const queryParams = humps.decamelizeKeys(notEmptyPayload(params))

  dispatch({
    type: GET_SERVICE_ORDERS_COUNT_WIDGET.ACTION,
    payload: widgetsServices.getServiceOrdersCountWidgets(getState().user.authToken)(queryParams),
  })
}

export const getWidgetsOptions = () => (dispatch, getState) => {
  const data = widgetsServices.getWidgetsOptions(getState().user.authToken)()
  dispatch({
    type: GET_WIDGETS_OPTIONS.ACTION,
    payload: data,
  })
  return data
}

export const getWidgetResults =
  ({ optionId, params }) =>
  (dispatch, getState) => {
    const queryParams = humps.decamelizeKeys(notEmptyPayload(params))
    const data = widgetsServices.getWidgetResults(getState().user.authToken)({
      optionId,
      params: queryParams,
    })
    dispatch({
      type: GET_WIDGET_RESULTS.ACTION,
      payload: data,
    })
    return data
  }

export const getWidgetsList = params => async (dispatch, getState) => {
  const data = await widgetsServices.getWidgetsList(getState().user.authToken)(
    humps.decamelizeKeys(notEmptyPayload(params))
  )
  dispatch({
    type: GET_WIDGETS_LIST.ACTION,
    payload: async () => data,
  })
  return data
}

export const createWidget = payload => async (dispatch, getState) => {
  const data = await widgetsServices.createWidget(getState().user.authToken)(payload)
  dispatch({
    type: CREATE_WIDGET.ACTION,
    payload: async () => data,
  })
  return data
}

export const updateWidget = (widgetId, payload) => async (dispatch, getState) => {
  const data = await widgetsServices.updateWidget(getState().user.authToken)(widgetId, payload)
  dispatch({
    type: UPDATE_WIDGET.ACTION,
    payload: async () => data,
  })
  return data
}

export const getWidgetDetails = widgetId => async (dispatch, getState) => {
  const data = await widgetsServices.getWidgetDetails(getState().user.authToken)(widgetId)
  dispatch({
    type: GET_WIDGET_DETAILS.ACTION,
    payload: async () => data,
  })
  return data
}

export const deleteWidget = widgetId => async (dispatch, getState) => {
  await widgetsServices.deleteWidget(getState().user.authToken)(widgetId)
  dispatch({
    type: DELETE_WIDGET.ACTION,
    payload: async () => widgetId,
  })
  return widgetId
}
